export default __webpack_public_path__ + "components/weather-icon/static/nightmodrain@3-daa82a83011035cba64eaee81e34ac0e.png";